import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { isMobileApp } from "@faire/retailer-visitor-shared/lib/isMobileApp";
import { getBrand } from "@faire/retailer-visitor-shared/serialized-data/getBrand";
import { getLocaleKey } from "@faire/retailer-visitor-shared/serialized-data/getLocaleKey";
import { RetailerStore } from "@faire/retailer-visitor-shared/stores/domain/RetailerStore";
import { MAKER_SIGN_UP_BASED_IN_STORAGE_KEY } from "@faire/retailer-visitor-shared/views/apply/MakerApplication/consts";
import { getLanguageAndCountrySpecificLink as _getLanguageAndCountrySpecificLink } from "@faire/web--source/common/localization/utils";
import { LocalStorage } from "@faire/web--source/common/Storage";
import { CountryGroup } from "@faire/web-api--source/indigofair/data/CountryGroup";
import { ISO3166Alpha3 } from "@faire/web-api--source/indigofair/iso3166/ISO3166Alpha3";
import { Language } from "@faire/web-api--source/indigofair/languages/Language";
export var ADDITIONAL_REQUIREMENTS_FOR_NET_TERMS_COUNTRIES = [
    ISO3166Alpha3.ITA,
    // T2
    ISO3166Alpha3.BEL,
    ISO3166Alpha3.AUT,
    ISO3166Alpha3.IRL,
    ISO3166Alpha3.LUX,
    // T3
    ISO3166Alpha3.CHE,
    ISO3166Alpha3.FIN,
    ISO3166Alpha3.DNK,
    ISO3166Alpha3.NOR,
    ISO3166Alpha3.SWE,
    ISO3166Alpha3.PRT
];
export var ANZ_COUNTRIES = [
    ISO3166Alpha3.AUS,
    ISO3166Alpha3.NZL
];
var NON_INTERNATIONAL_COUNTRIES = [
    ISO3166Alpha3.CAN,
    ISO3166Alpha3.USA
];
export var RESTRICTED_COUNTRIES_TOS = _to_consumable_array(NON_INTERNATIONAL_COUNTRIES).concat(_to_consumable_array(ADDITIONAL_REQUIREMENTS_FOR_NET_TERMS_COUNTRIES), _to_consumable_array(ANZ_COUNTRIES));
export var NON_EU_AND_ITALY = _to_consumable_array(NON_INTERNATIONAL_COUNTRIES).concat(_to_consumable_array(ANZ_COUNTRIES), [
    ISO3166Alpha3.ITA
]);
export function getLanguageAndCountrySpecificLink(linkByLanguage, zendeskDatafallback) {
    var _getLocaleKey, // To handle brands in preview mode
    _getBrand;
    var language = (_getLocaleKey = getLocaleKey()) === null || _getLocaleKey === void 0 ? void 0 : _getLocaleKey.language;
    var _getBrand_based_in, _ref;
    var country = (_ref = (_getBrand_based_in = (_getBrand = getBrand()) === null || _getBrand === void 0 ? void 0 : _getBrand.based_in) !== null && _getBrand_based_in !== void 0 ? _getBrand_based_in : // To handle brand sign-up
    LocalStorage.get().getItem(MAKER_SIGN_UP_BASED_IN_STORAGE_KEY)) !== null && _ref !== void 0 ? _ref : RetailerStore.get().retailerCountry;
    // If zendeskDatafallback fallback is undefined,
    // the data requested (returned) must be a URL, i.e. a string
    var shouldReturnPdfLink = !zendeskDatafallback;
    if (!language || !country) {
        return zendeskDatafallback;
    }
    var navigatedToData = _getLanguageAndCountrySpecificLink({
        linkByLanguage: linkByLanguage,
        language: language,
        country: country,
        region: RetailerStore.get().isEurope ? CountryGroup.EUROPE : undefined,
        isPdf: shouldReturnPdfLink && isMobileApp()
    });
    /*
    If we cannot find a link for the chosen language, we can try to
    find the article in a fallback language, typically english.
  
    The use-case here is a retailer in France with language set to Italian.
    They will have country = FRA and region = EU
  
    If there is no Italian TOS available (since our TOS is specific to country = ITA)
    we still want to show the EU TOS, however we don't have this available in Italian,
    so we specify ENG as the fallback language.
     */ if (!navigatedToData) {
        language = Language.ENG;
        navigatedToData = _getLanguageAndCountrySpecificLink({
            linkByLanguage: linkByLanguage,
            language: Language.ENG,
            country: country,
            region: RetailerStore.get().isEurope ? CountryGroup.EUROPE : undefined,
            isPdf: shouldReturnPdfLink && isMobileApp()
        });
    }
    if (!zendeskDatafallback) {
        return navigatedToData;
    }
    if (!navigatedToData) {
        return zendeskDatafallback;
    }
    return {
        linkOrId: navigatedToData,
        locale: language
    };
}
